var _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 483.9 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 92.444,
    y1: -34.806,
    x2: 387.724,
    y2: 260.474,
    gradientTransform: "matrix(1 0 0 -1 0 251.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5a717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6511f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M40.7 187.3c0 10.6-6.4 15.4-20.2 15.4-14.1 0-20.5-5.1-20.5-15.4V61c0-11.3 5.4-16.1 17.6-16.1 11.3 0 15.1 2.5 17.6 12.2.6 1.9 1.6 2.9 2.5 2.9 1 0 1.6-.4 3.8-2.5C49.5 49.8 63 45 76.8 45c8.3 0 12.5 4.4 12.5 13.2 0 20.2-3.8 27.6-13.8 27.6-24.4 0-35.9 13.2-34.9 39.7v61.8zm63.8-171.2C104.5 5.2 111 0 124.8 0c14.2 0 20.5 5.2 20.5 16.1v23c0 4.8 1.6 6.4 6.4 6.4h10.9c10.9 0 16.1 6.1 16.1 19.2 0 12.8-5.2 19-16.1 19h-10.9c-4.4 0-6.4 1.9-6.4 6.4v48.1c0 21.8 7.1 32.4 21.5 32.4 3.5 0 7.1-.4 16.7-1.3 1-.4 1.9-.4 3.2-.4 7.1 0 10.2 3.5 10.2 11.9 0 15.7-13.8 24.4-38.2 24.4-35.9 0-54.2-23.4-54.2-69.3V16.1zm181.3 51.6c6.5-18.6 11.3-23 24.4-23 12.2 0 18.6 4.8 18.6 13.8 0 2.3-.4 3.2-1.6 7.1l-42.7 115.1c-6.5 17.6-11.5 22.1-24.4 22.1-12.8 0-18-4.4-24.4-22.1L193.1 65.5c-1.3-3.2-1.6-4.8-1.6-7.1 0-9 6.5-13.8 18.6-13.8 13.2 0 17.6 4.4 24 23l21.5 61.9c1 2.5 2.3 3.8 4.4 3.8 1.9 0 3.5-1.3 4.2-3.8l21.6-61.8zm89.5 90.5c-3.8 0-5.4 1.6-5.4 4.8 0 31.8 20.9 51.4 55.2 51.4 12.2 0 20.5-1.9 35.6-8 5.2-1.9 7.3-2.5 9.6-2.5 5.4 0 9.4 4.8 9.4 12.2 0 19.2-26.3 34-61.2 34-57.1 0-89.2-36.6-89.2-101.7 0-64.5 30.8-103.3 81.7-103.3 43.6 0 72.9 32.8 72.9 81.5 0 24.4-6.4 31.8-27.8 31.8h-80.8v-.2zm64.1-32.4c3.8 0 5.2-1.6 5.2-5.8 0-29.5-12.8-45.5-35.9-45.5-22.8 0-38.2 19.2-38.2 46.8 0 2.9 1.9 4.4 5.2 4.4 0 .1 63.7.1 63.7.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtve);
export default __webpack_public_path__ + "static/media/RTVE.e95075bf8ae17db2f58a71ed71194d46.svg";
export { ForwardRef as ReactComponent };